import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { UpdateEstadoPostulacionRequest } from '../../empresa/requests/update-estado-postulacion-request';
import { DocenteService } from '../services/docente.service';

@Component({
  selector: 'app-doc-postulante-detalles',
  templateUrl: './doc-postulante-detalles.component.html',
  styleUrls: ['./doc-postulante-detalles.component.css']
})
export class DocPostulanteDetallesComponent implements OnInit{
  datosPostulante;
  detallesPostulante;

  validResult = false;
  hasPostulacion = false;
  constructor(private _route: ActivatedRoute,
              private router : Router,
              private toastr : ToastrService,
              private docenteService : DocenteService){
  }

  async ngOnInit() 
  {
    this._route.queryParams.subscribe((params) => {
      if (params.postulante) {
        this.datosPostulante = JSON.parse(params.postulante);
        if(this.datosPostulante.postulacion==='Aceptada' || this.datosPostulante.postulacion==='Rechazada')
            this.hasPostulacion=true;
      }
    });
    this.validResult = await this.DetallesPostulante();

    if(!this.datosPostulante || !this.validResult)
    {
      this.toastr.error('No se ha podido recuperar la información relacionada al postulante de la oferta de trabajo.','Error');
      this.router.navigate(['empresa/ofertasPublicadas'], 
      {
        queryParams: {},
        skipLocationChange: true
      });
    }
  }

  async DetallesPostulante() : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.docenteService.getDetallesPostulante(this.datosPostulante.idUsuario));
      if(data)
      {
        this.detallesPostulante=data;
        return true;
      }
      else
        return false;
    } 
    catch (error) 
    {
      return false;
    }
  }

  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  async onReject() : Promise<void>
  {
    try {
      let request = {} as UpdateEstadoPostulacionRequest;
      request.accion = 2;
      request.idPostulacion = this.datosPostulante.idPostulacion;
      await this.docenteService.updateEstadoPostulacion(request).subscribe(result =>
      {
        if(!result.success) 
        {
          this.toastr.error('Error al actualizar el estado de la postulación.','Error');
        }
        else
          this.toastr.warning('Solicitud rechazada.','Hecho');
        this.router.navigate(['docente/ofertasPublicadas']);
      });
    } 
    catch (error) 
    {
      this.toastr.error('Hubo un error con el servidor.','Error');
    }
  }

  async onSuccess() : Promise<void>
  {
    try 
    {
      let request = {} as UpdateEstadoPostulacionRequest;
      request.accion = 1;
      request.idPostulacion = this.datosPostulante.idPostulacion;
      await this.docenteService.updateEstadoPostulacion(request).subscribe(result =>
      {
        if(!result.success) 
        {
          this.toastr.error('Error al actualizar el estado de la postulación.','Error');
        }
        else
          this.toastr.success('Solicitud aceptada.','¡Gracias!');
        this.router.navigate(['docente/ofertasPublicadas']);
      });
    } catch (error) 
    {
      this.toastr.error('Hubo un error con el servidor.','Error');
    }
  }
}
